module.exports = __webpack_public_path__ + "static/japan13-e4acda1fcd0b97c390ebc69514911560.jpg";